import { analyticsPageData, analyticsPageName } from "./analyticsConfig";
import { SiteflowResponse } from "../types/ContentfulTypes";
// @ts-ignore
import { fireImpression } from "@vp/ab-reader";

const fireSiteflowExperiments = (simplifiedFlow: SiteflowResponse, mpvId: string) => {
  for (const experimentDefinition of simplifiedFlow.context) {
    // excluding NA_Brochures_Studio3D experiment from getting triggered on page load
    if (experimentDefinition.experiment !== "NA_Brochures_Studio3D") {
      fireImpression(experimentDefinition.experiment, experimentDefinition.variation, {
        pageName: analyticsPageName(mpvId),
        pageSection: analyticsPageData.pageSection,
        pageStage: analyticsPageData.pageStage,
      });
    }
  }
};

export { fireSiteflowExperiments };
